import { LightningElement, api, track } from 'lwc';
import { mapTemplateLabels, TEMPLATE_LABELS } from '../../../utils/languageUtil';


const PROPERTIES = [
    'street',
    'county',
    'city',
    'state',
    'zip_code',
    'country',
];

const ADDRESS_SKELETON = {
    street: {value: null, required: false, disabled: false, requiredCondition: null},
    county: {value: null, required: false, disabled: false, requiredCondition: null},
    city: {value: null, required: false, disabled: false, requiredCondition: null},
    state: {value: null, required: false, disabled: false, requiredCondition: null},
    zip_code: {value: null, required: false, disabled: false, requiredCondition: null},
    country: {value: null, required: false, disabled: false, requiredCondition: null}
};

export default class sldsFormElementAddress extends LightningElement {
    templateLabels = mapTemplateLabels(TEMPLATE_LABELS);
    
    _formElement = ADDRESS_SKELETON;

    @api 
    set address(val) {
        try {
            this._address = val;
            if (val) {
                const newFormElement = Object.fromEntries(
                    Object.entries(ADDRESS_SKELETON).map(([k, v]) => [k, { ...v }])
                );
                if (Array.isArray(val)) {
                    val.forEach(item => {
                        const fieldApiName = item?.fieldApiName;
                        if (fieldApiName && newFormElement?.[fieldApiName]) {
                            newFormElement[fieldApiName] = {
                                value: item?.value ?? null,
                                required: item?.required ?? false,
                                requiredCondition: item?.requiredCondition ?? null
                            }
                        }
                    })
                } else if (typeof val === 'object' && Array.from(Object.keys(val))?.length) {
                    PROPERTIES.forEach(prop => {
                        if (val?.[prop]) {
                            newFormElement[prop] = {
                                value: val[prop] ?? null,
                                required: false,
                                requiredCondition: null
                            }
                        }
                    })
                }
                this._formElement = newFormElement;
            }
        } catch(error) {
            this.showToast('Error in set address() of sldsFormElementAddress.js', getErrorMessage(error), 'error');
        }
    }
    get address() {
        return this._address;
    }

    @api 
    set street(val) {
        this._street = val;
        //console.log('herre is street in sldsFormElementAddress.js: ', val);
    }
    get street() {
        return this._street;
    }

    
    @api mobile = false;
    @api suppressCounty = false;

    @api // Strucure {street: (val) => val.length === 5, city: (val, citiesArr) => citiesArr.some(city => val === city) }
    set requiredFields(val) {
        this._requiredFields = val;
        try {
            if (val) {
                Object.entries(val ?? {}).forEach(([key, val]) => {
                    if (this._formElement?.[key]) {
                        this._formElement[key] = {...this._formElement[key], required: true}
                    }
                })
            }
        } catch(error) {
            console.error('Error in set requiredFields() of sldsFormElementAddress.js', getErrorMessage(error), 'error');
        }
    }
    get requiredFields() {
        return this._requiredFields;
    }

    handleChange(event) {
        const ele = event.target?.dataset?.fieldApiName
            ? event.target
            : event.currentTarget;

        if (ele?.dataset?.fieldApiName) {
            const fieldApiName = ele.dataset.fieldApiName;
            const value = ele.value;
            this._formElement = {
                ...this._formElement,
                [fieldApiName]: {
                    ...this._formElement[fieldApiName],
                    value 
                }
            };
            this.dispatchEvent(new CustomEvent('change', 
                { detail: {fieldApiName, value} } 
            ));
        }
    }
    handleNewInput(event) {
        const fieldApiName = event.target.dataset.fieldApiName;
        const value = event.detail.value; 
        this._formElement = {
            ...this._formElement,
            [fieldApiName]: {
                ...this._formElement[fieldApiName],
                value 
            }
        };
        this.dispatchEvent(new CustomEvent('change', 
            { detail: {fieldApiName, value} } 
        ));

    }

    @api getValue() {
        return Object.fromEntries(
            Object.entries(this._formElement).map(([k, v]) => [k, v.value])
        );
    }

    
}